import React, { useState } from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const leaders = [{
  name: 'Edward Albers',
  title: 'Chief Executive Officer',
  initials: 'EA',
  shortBio: 'Edward Albers is the CEO of New River Systems Corporation, which he founded in March 2007. Prior to establishing New River Systems, Mr. Albers held leadership positions for various aerospace & defense, software, and high technology companies including Northrop Grumman, SAP America, and Intel Corporation.',
  fullBio: 'Edward Albers is the CEO of New River Systems Corporation, which he founded in March 2007. Prior to establishing New River Systems, Mr. Albers held leadership positions for various aerospace & defense, software, and high technology companies including Northrop Grumman, SAP America, and Intel Corporation. He brings a wealth of experience in federal contracting and enterprise IT solutions.'
}, {
  name: 'Jason Erdman',
  title: 'President & Chief Operating Officer',
  initials: 'JE',
  shortBio: 'Jason Erdman is the President and COO of New River Systems. He brings nearly 20 years of experience building and managing businesses focused on providing information technology and consulting services to Federal and commercial clients.',
  fullBio: 'Jason Erdman is the President and COO of New River Systems. He brings nearly 20 years of experience building and managing businesses focused on providing information technology and consulting services to Federal and commercial clients. His operational leadership ensures New River Systems delivers on its commitments to mission-critical programs.'
}, {
  name: 'Greg LeTourneau',
  title: 'Chief Technology Officer',
  initials: 'GL',
  shortBio: 'Greg LeTourneau is the CTO of New River Systems. Mr. LeTourneau brings 20 years of comprehensive technical experience designing, developing and delivering software and IT solutions from enterprise systems to niche commercial applications.',
  fullBio: "Greg LeTourneau is the CTO of New River Systems. Mr. LeTourneau brings 20 years of comprehensive technical experience designing, developing and delivering software and IT solutions from enterprise systems to niche commercial applications. He leads the technical strategy and innovation for New River Systems' ServiceNow and ICAM practices."
}, {
  name: 'Julie Householder',
  title: 'Chief Financial Officer',
  initials: 'JH',
  shortBio: 'Julie Householder is the Chief Financial Officer for New River Systems. With 20 years of experience in government contract financial activities, Ms. Householder sets the strategic financial direction for New River Systems overseeing Finance, Accounting, and Contracts.',
  fullBio: 'Julie Householder is the Chief Financial Officer for New River Systems. With 20 years of experience in government contract financial activities, Ms. Householder sets the strategic financial direction for New River Systems overseeing Finance, Accounting, and Contracts. Her expertise ensures compliance and financial stability.'
}, {
  name: 'Emmanuel Twum',
  title: 'Vice President, ERP Advisory Services',
  initials: 'ET',
  shortBio: "Emmanuel Twum is the Vice President of New River Systems' ERP Advisory Services. Twum earned a bachelor's degree from Westminster College, and a master's degree in E-commerce technology from DePaul University.",
  fullBio: "Emmanuel Twum is the Vice President of New River Systems' ERP Advisory Services. Twum earned a bachelor's degree from Westminster College, and a master's degree in E-commerce technology from DePaul University. He leads the ERP practice, delivering complex enterprise solutions to federal clients."
}, {
  name: 'Fred Nicholas',
  title: 'Vice President, DOD Programs',
  initials: 'FN',
  shortBio: "Fred Nicholas is the Vice President of New River Systems' DoD Programs. He brings over 30 years of experience in both the federal and private sectors supporting defense, health care, automotive and aerospace industries.",
  fullBio: "Fred Nicholas is the Vice President of New River Systems' DoD Programs. He brings over 30 years of experience in both the federal and private sectors supporting defense, health care, automotive and aerospace industries. His experience spans from Manufacturing and Engineering to Logistics and Information Technology (IT) and he has helped lead complex organizations at all levels to achieve award-winning business and operations milestones."
}];
function LeaderCard({
  leader
}: {
  leader: (typeof leaders)[0];
}) {
  const [expanded, setExpanded] = useState(false);
  return <div className="card flex flex-col h-full" data-id="element-1853" data-mp="2x4ejol9hmu74">
      <div className="flex items-center gap-6 mb-6" data-id="element-1854" data-mp="2x5pnum6ui3yr">
        <div className="w-24 h-24 rounded-full bg-nrs-navy flex items-center justify-center text-white text-3xl font-bold flex-shrink-0" data-id="element-1855" data-mp="10bl84hog10dg">
          {leader.initials}
        </div>
        <div data-id="element-1856" data-mp="vaxcfip9rvcw">
          <h3 className="text-2xl font-bold mb-1" data-id="element-1857" data-mp="12wkgvksgh69i">{leader.name}</h3>
          <p className="text-lg font-bold text-nrs-gray" data-id="element-1858" data-mp="12u6o5il90654">{leader.title}</p>
        </div>
      </div>
      <div className="flex-grow" data-id="element-1859" data-mp="17taw65wfrxtv">
        <p className="text-nrs-gray leading-relaxed mb-4" data-id="element-1860" data-mp="1clkjde662jsg">
          {expanded ? leader.fullBio : leader.shortBio}
        </p>
      </div>
      <button onClick={() => setExpanded(!expanded)} className="text-nrs-navy font-bold text-left hover:underline mt-auto self-start" data-id="element-1861" data-mp="1hjvwpyvo7cff">
        {expanded ? 'Read Less' : 'Read More'}
      </button>
    </div>;
}
export function LeadershipPage() {
  const [expandedBio, setExpandedBio] = useState<string | null>(null);
  return <div className="w-full" data-id="element-1862" data-mp="txpcme8z268u">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-1863" data-mp="xxg7ou5j78j6">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1864" data-mp="xuv8ye0j58pn">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-1865" data-mp="25cufpjd0m6sz">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-1866" data-mp="29as5anap6uww">
              Leadership Team
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-1867" data-mp="58ifbal0m94s"></div>
            <p className="text-xl text-nrs-light font-bold max-w-2xl mx-auto" data-id="element-1868" data-mp="5auvpjb4kbfq">
              Guiding New River Systems with decades of federal IT experience
            </p>
          </motion.div>
        </div>
      </section>

      {/* LEADERSHIP GRID */}
      <section className="section-white" data-id="element-1869" data-mp="3mptcb8wo1ob2">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1870" data-mp="3mmnkvn0keac6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1871" data-mp="3iozla6nxftdy">
            {leaders.map((leader, idx) => <LeaderCard key={idx} leader={leader} data-id="element-1872" data-mp="b05zj335rw9" data-mpi={idx} />)}
          </div>
        </div>
      </section>
    </div>;
}